export const TITLE_LENGTH_LIMIT = 256;
export const SUMMARY_LENGTH_LIMIT = 500;
export const DESCRIPTION_LENGTH_LIMIT = 10000;
export const REQUIREMENTS_LENGTH_LIMIT = 10000;
export const BLOB_URL_LENGTH_LIMIT = 500;
export const SUPPORTED_IMAGE_TYPES = ['jpg', 'jpeg', 'png', 'gif', 'bmp'];
